﻿import React from 'react';
import { motion } from 'framer-motion';

import { DynamicFormErrorWrapper } from '../../DynamicForms/Styles/dynamicFormStyles';

const DynamicFormError = (props) => {
    return (
        <DynamicFormErrorWrapper>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
            >
                <span>{props.children}</span>
            </motion.div>
        </DynamicFormErrorWrapper>
    );
};

export default DynamicFormError;
